import moment from 'moment';

export const DateForm = (date: any) =>
  date ? moment(date).format('DD/MM/YYYY') : '';

export const DateFormAndTime = (date: any) =>
  date ? moment(date).format('DD/MM/YYYY - HH:mm') : '';
